<template>
  <div v-if="isShow">
    <myInfo :certNo="certNo" style="min-height: 200px"></myInfo>
    <van-button style="width: 100%;" size="large" type="info" @click="goPage">补偿申请</van-button>
  </div>
</template>

<script>
import myInfo from '@/components/order/myInfo';
import Vue from 'vue';
export default {
  name: "myOrderInfo",
  data(){
    return{
      certNo:'',
      isShow:false
    }
  },
  components: {
    myInfo
  },
  mounted() {
      let c_Id = this.$route.params.credId
    this.certNo = c_Id
    this.isShow = true
    console.log("c_Id",c_Id)
    },
  methods:{
    goPage(){
      this.$router.push('/settlementInfo/'+this.certNo);
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// myOrderInfo.vue?1c92d308